/* Zabi Hair — trust-strip als mobiele slider: 1 item tegelijk, autoplay.
   Desktop toont alle items (CSS); dit script roteert alleen <750px. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var strip = document.querySelector('.zabi-pdp-trust');
  if (!strip) return;
  var items = strip.querySelectorAll('.zabi-pdp-trust__item');
  if (items.length < 2) return;
  var i = 0;
  var timer = null;

  function show(n) {
    items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === n); });
  }
  function start() {
    if (timer) return;
    timer = setInterval(function () {
      i = (i + 1) % items.length;
      show(i);
    }, 3500);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    show(0); i = 0;
  }
  function sync() { mq.matches ? start() : stop(); }
  mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  sync();
})();
